export default __webpack_public_path__ + "static/media/ic_republic_of_macedonia.d738978e.svg";